import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { App } from './app';
import { getAppProps } from './utils/get-app-props';
const pageWithProviders = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;
const pageType = window.__PRELOADED_PAGE_TYPE__;
delete window.__PRELOADED_PAGE_TYPE__;
ReactDOM.hydrateRoot(document.getElementById('root'), _jsx(App, { ...getAppProps(pageWithProviders, pageType) }));
